import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GateronMilkyYellow = () => (
  <ArticleWrapper articleId="gateron_milky_yellow">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Gateron Milky Yellow</h1>
        {/* Add your Gateron Milky Yellow article content here */}
        <p>This is a placeholder article for the Gateron Milky Yellow switch. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GateronMilkyYellow;
